import { KEYS } from './l18n/constants';

const ENV =
  !!window &&
  ('_globalPartnerFinderServerData' in window) &&
  ('env' in window['_globalPartnerFinderServerData']) ?
    window['_globalPartnerFinderServerData'].env :
    'dev';

const APP_SERVER_CONTEXT_PATH =
  !!window &&
  ('_globalPartnerFinderServerData' in window) &&
  ('serverContextPath' in window['_globalPartnerFinderServerData']) ?
    window['_globalPartnerFinderServerData'].serverContextPath :
    '/tomcat7';

//const SSO_LOGIN_URL_DEV = 'https://fdk-devint.cisco.com/c/login/index.html?referer=';
//const SSO_LOGIN_URL_STAGE = 'https://fdk-stage.cisco.com/c/login/index.html?referer=';
//const SSO_LOGIN_URL_PROD = 'https://www.cisco.com/c/login/index.html?referer=';

const SSO_LOGIN_URL_DEV = 'https://locatr-dev.cloudapps.cisco.com/WWChannels/LOCATR/pf/login.jsp';
const SSO_LOGIN_URL_STAGE = 'https://locatr-stage.cloudapps.cisco.com/WWChannels/LOCATR/pf/login.jsp';
const SSO_LOGIN_URL_PROD = 'https://locatr.cloudapps.cisco.com/WWChannels/LOCATR/pf/login.jsp';

const SSO_LOGIN_URL =
  ENV === 'dev' ?
    SSO_LOGIN_URL_DEV :
    ENV === 'stage' ?
      SSO_LOGIN_URL_STAGE :
      ENV === 'prod' ?
        SSO_LOGIN_URL_PROD :
        SSO_LOGIN_URL_DEV;

const SSO_LOGOUT_URL_DEV = 'https://locatr-dev.cloudapps.cisco.com/WWChannels/LOCATR/pf/logout.jsp';
const SSO_LOGOUT_URL_STAGE = 'https://locatr-stage.cloudapps.cisco.com/WWChannels/LOCATR/pf/logout.jsp';
const SSO_LOGOUT_URL_PROD = 'https://locatr.cloudapps.cisco.com/WWChannels/LOCATR/pf/logout.jsp';

const SSO_LOGOUT_URL =
  ENV === 'dev' ?
    SSO_LOGOUT_URL_DEV :
    ENV === 'stage' ?
      SSO_LOGOUT_URL_STAGE :
      ENV === 'prod' ?
        SSO_LOGOUT_URL_PROD :
        SSO_LOGOUT_URL_DEV;


//SSO_LOGOUT_URL_DEV: 'https://www-dev.cisco.com/autho/logout.html?ReturnUrl=https://www-dev.cisco.com/web/fw/lo/logout.html?locale=en_us',
//SSO_LOGOUT_URL_STAGE: 'https://www-stage.cisco.com/autho/logout.html?ReturnUrl=https://www-stage.cisco.com/web/fw/lo/logout.html?locale=en_us',
//SSO_LOGOUT_URL_PROD: 'https://www.cisco.com/autho/logout.html?ReturnUrl=https://www.cisco.com/web/fw/lo/logout.html?locale=en_us',

const METHOD_POST = 'POST';
const METHOD_GET = 'GET';

const CREDENTIALS_SAME_ORIGIN = 'same-origin';
const CREDENTIALS_OMIT = 'omit';
const CREDENTIALS_INCLUDE = 'include';

const MODE_SAME_ORIGIN = 'same-origin';
const MODE_CORS = 'cors';
const MODE_NO_CORS = 'no-cors';

const HEADER_CONTENT_TYPE = 'Content-Type';
const CONTENT_TYPE_APPLICATION_JSON = 'application/json';
const CONTENT_TYPE_TEXT_PLAIN = 'text/plain; charset=UTF-8';

const ELOQUA_FORM_URL_GET_GUIDANCE = 'https://engage2demand.cisco.com/LP=27116';
const ELOQUA_FORM_URL_GET_QUOTE = 'https://engage2demand.cisco.com/LP=27249';
const ELOQUA_FORM_GET_QUOTE_AUTHORIZED_BE_GEO_IDS = ['44','94913']; // no longer used. back-end driven.

const KEY_NAME = 'name';
const KEY_CODE = 'code';
const KEY_IS_SELECTED = 'isSelected';
const KEY_IS_ACTIVE = 'isActive';
const KEY_IS_DISABLED = 'isDisabled';
const KEY_IS_GROUP = 'isGroup';
const KEY_GROUP = 'group';
const KEY_TYPE = 'type';
const KEY_SUBTYPE = 'subtype';
const KEY_ORIGINAL_DATA = 'originalData'
const KEY_KEYWORD_ID = 'keyword_id';
const KEY_SEARCH_PARAM = 'SEARCH_PARAM';
const KEY_KEYWORD_IDS = 'KEYWORD_IDS';
const KEY_KEYWORD_DISPLAY_NAME = 'keyword_display_name';
const KEY_CATEGORY_ID = 'category_id';
const KEY_CATEGORY_DISPLAY_NAME = 'category_display_name';
const KEY_PARENT_CATEGORY_ID = 'parent_category_id';
const KEY_PARENT_CATEGORY_DESC = 'parent_category_desc';
const KEY_DOCLIST = 'doclist';
const KEY_GROUPVALUE = 'groupValue';
const KEY_JSONKEY = 'jsonKey';
const KEY_KEYWORD_SUBTEXT = 'keyword_subtext';


const KEY_LOCATION_IDS = 'LOCATION_IDS';
const KEY_SPECIALIZATION_IDS = 'SPECIALIZATION_IDS';
const KEY_LEVEL_IDS = 'LEVEL_IDS';
const KEY_SITE_ID = 'SITE_ID';
const KEY_SITE_ID_LOWERCASE = 'site_id';
const KEY_SITEID = 'siteId';
const KEY_SITE_IDS = 'SITE_IDS';
const KEY_SORT_ORDER = 'SORT_ORDER';
const KEY_SORT_BY = 'SORT_BY';
const KEY_PAGE_SIZE = 'pageSize';
const KEY_PAGE_COUNT = 'pageCount';
const KEY_PARTNER_KEYWORD_ID = 'PARTNER_KEYWORD_ID';
const KEY_PARTNER_KEYWORD_IDS = 'PARTNER_KEYWORD_IDS';

const KEY_QUAL_ICONS = 'qual_icons';
const KEY_GLOBAL_GOLD_CERTIFICATION = 'globalGoldCertification';
const KEY_CERTIFICATION = 'certification';
const KEY_MASTER = 'master';
const KEY_SMB = 'smb';
const KEY_CUSTOMER = 'customer';
const KEY_PROVIDER_LOWERCASE = 'provider';
const KEY_ROLES_AND_LEVELS = 'rolesAndLevels';
const KEY_INTEGRATOR = 'Integrator';
const KEY_PROVIDER = 'Provider';
const KEY_DEVELOPER = 'Developer';
const KEY_ADVISOR = 'Advisor';
const KEY_IS_SAVED = 'isSaved';

const KEY_ATTRIBUTE_LIST_TITLE = 'attributeListTitle';
const KEY_ATTRIBUTE_LIST_ITEMS = 'attributeListItems';

const KEY_FAVPARTNERLIST = 'favPartnerList';

const KEY_USE_GRID_DISPLAY = 'useGridDisplay';

const VALUE_Y = 'Y';
const VALUE_N = 'N';
const VALUE_PARTNER_ROLE = 'Partner Role';
const VALUE_INTEGRATOR = 'Integrator';
const VALUE_PROVIDER = 'Provider';
const VALUE_DEVELOPER = 'Developer';
const VALUE_ADVISOR = 'Advisor';
const VALUE_PARTNER_LEVEL = 'Partner Level';
const VALUE_PARTNER_SPECIALIZATION = 'Partner Specialization';
const VALUE_CISCO_POWERED_SERVICE = 'Cisco Powered Service';
const VALUE_PARTNER_NAME = 'Partner Name';
const VALUE_LOCATION = 'Location';
const VALUE_COUNTRY = 'Country';
const VALUE_PARTNER_NAME_KEYWORD = 'Partner Name Keyword';
const VALUE_PARTNER_NAME_KEYWORD_S_ = 'Partner Name Keyword(s)';
const VALUE_SORTING = 'Sorting';

const VALUE_SPECIALIZATIONS = 'Specializations';
const VALUE_PARTNER_SPECIALIZATIONS = 'Partner Specializations';
const VALUE_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES = 'Provider Level and Cisco Powered Services';

const VALUE_GOLD_PROVIDER = 'gold provider';
const VALUE_PREMIER_PROVIDER = 'premier provider';
const VALUE_SELECT_PROVIDER = 'select provider';

const VALUE_DIVERSE_PARTNERS = 'Diverse Partners';

const GROUPVALUE_PARTNER_LEVEL = 'Partner level';
const GROUPVALUE_PARTNER_SPECIALIZATIONS = 'Partner Specializations';
const GROUPVALUE_PARTNER_NAME = 'Partner Name';

const GROUP_NAME_VALUE_SEARCH_TERMS = 'search_terms';

const LABEL_ELOQUA__GET_GUIDANCE = 'Get guidance';
const LABEL_ELOQUA__REQUEST_A_QUOTE = 'Request a quote';

const LABEL_OPEN = 'Open';
const LABEL_EXPAND = 'Expand';
const LABEL_COLLAPSE = 'Collapse';
const LABEL_CHOOSE_A_COUNTRY = 'Choose a country/region';
const LABEL_CHOOSE_A_ROLE = 'Choose a role';
const LABEL_CHOOSE_SPECIALIZATION_S_ = 'Choose specialization(s)';
const LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ = 'Choose Cisco Powered Service(s)';
const LABEL_CHOOSE_EXPERTISE_S = 'Choose Expertise(s)';
const LABEL_CHOOSE_LEVEL_S_ = 'Choose level(s)';

const LABEL_PARTNER_SPECIALIZATION = 'Partner Specialization';
const LABEL_CISCO_POWERED_SERVICE = 'Cisco Powered Service';
const LABEL_PARTNER_EXPERTISE = 'Partner Expertise';
const LABEL_PARTNER_COUNTRY = 'Partner Country/Region'

const LABEL_INTEGRATOR_LEVELS = 'Integrator Levels';
const LABEL_PROVIDER_LEVELS = 'Provider Levels';
const LABEL_DEVELOPER_LEVELS = 'Developer Levels';
const LABEL_ADVISOR_LEVELS = 'Advisor Levels';
const LABEL_INTEGRATOR_SPECIALIZATIONS = 'Integrator Specializations';
const LABEL_CISCO_POWERED_SERVICES = 'Cisco Powered Services';
const LABEL_PARTNER_NAMES = 'Partner Names';
const LABEL_PARTNER_NAME_KEYWORD = 'Partner Name Keyword';
const LABEL_PARTNER_NAME_KEYWORD_S_ = 'Partner Name Keyword(s)';

const LABEL_BACK = 'Back';

const LABEL_ALL_RESULTS = 'All results';
const LABEL_ALL = 'All';
const LABEL_SAVED = 'Saved';
const LABEL_MY_PARTNERS = 'My Partners';

const LABEL_ADD = 'Add';
const LABEL_REMOVE = 'Remove';
const LABEL_ADD_TO_COMPARE = 'L18N_KEY_LABEL_ADD_TO_COMPARE';
const LABEL_SELECT_AT_LEAST_ONE_MORE = 'L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE';
const LABEL_COMPARE_SELECTED = 'L18N_KEY_LABEL_COMPARE_SELECTED';
const LABEL_REMOVE_FROM_COMPARATOR = 'L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR';
const LABEL_COMPARE = 'L18N_KEY_LABEL_COMPARE';

const LABEL_PARTNER_LEVEL = 'Partner Level';
const LABEL_PARTNER_NAME = 'Partner Name';
const LABEL_PROCESSING_IN_PROGRESS = 'Processing in progress...';

const LABEL_RESULT = 'result';
const LABEL_RESULTS = 'results';
const LABEL_NO_RESULTS = 'No results';
const LABEL_RESULT_IN_= 'result in';
const LABEL_RESULTS_IN_ = 'results in';
const LABEL_NO_RESULTS_IN_ = 'No results in';

const LABEL_PREVIOUS = 'Previous';
const LABEL_PREV = 'Prev';
const LABEL_NEXT = 'Next';
const LABEL_SAVE = 'Save';
const LABEL_EXPERTISE = 'Expertise';
const LABEL_OVERVIEW = 'Overview';
const LABEL_IS_A_CISCO = 'is a Cisco';
const LABEL_ROLE_INTEGRATOR_DESCRIPTION = 'L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION'//'Integrators build end-to-end solutions for our customers. They primarily transact in a resale motion but bring their own unique expertise to solve customer business problems.';
const LABEL_ROLE_PROVIDER_DESCRIPTION = 'L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION'//'Providers are experts at delivering managed and cloud solutions. Customers are looking for more flexibility in how they consume solutions and providers are becoming more and more critical in the market.';
const LABEL_ROLE_DEVELOPER_DESCRIPTION = 'L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION';
const LABEL_ROLE_ADVISOR_DESCRIPTION = 'L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION';
const LABEL_SPECIALIZATIONS = 'Specializations';

const LABEL_PAST_SEARCHES = 'Past searches';
const LABEL_PAST_SEARCH = 'Past search';

const LABEL_ROLES = 'Roles';
const LABEL_TECHNOLOGY = 'Technology';
const LABEL_INDUSTRIES = 'Industries';

const LABEL_INTEGRATOR = 'Integrator';
const LABEL_INTEGRATORS = 'Integrators';
const LABEL_PROVIDER = 'Provider';
const LABEL_PROVIDERS = 'Providers';
const LABEL_DEVELOPER = 'Developer';
const LABEL_DEVELOPERS = 'Developers';
const LABEL_ADVISOR = 'Advisor';
const LABEL_ADVISORS = 'Advisors';

const LABEL_OTHER = 'Other';
const LABEL_OTHERS = 'Others';

const LABEL_NO_SAVED_OTHER_PARTNERS = 'No other partners saved.';

const LABEL_NO_SAVED_INTEGRATORS = 'No saved integrators.';
const LABEL_NO_SAVED_PROVIDERS = 'No saved providers.';

const FORM_FILTER_BY_NEED = 'filter by need';
const FORM_SEARCH_BY_COMBINED_CRITERIA = 'search by combined criteria';
const FORM_SEARCH_BY_LOCATION = 'search by location'


const NOTIFICATION_TYPE_INFO = 'info';
const NOTIFICATION_TYPE_SUCCESS = 'success';
const NOTIFICATION_TYPE_WARNING = 'warning';
const NOTIFICATION_TYPE_ALERT = 'alert';

const DELAY_INFINITE = -1;
const DELAY_MILLISECONDS_150 = 150;
const DELAY_MILLISECONDS_200 = 200;
const DELAY_MILLISECONDS_300 = 300;
const DELAY_MILLISECONDS_500 = 500;
const DELAY_MILLISECONDS_3000 = 3000;
const DELAY_MILLISECONDS_5000 = 5000;
const DELAY_MILLISECONDS_7000 = 7000;

const COMPARATOR_MIN_ITEM_COUNT_LIMIT = 2;
const COMPARATOR_MAX_ITEM_COUNT_LIMIT = 4;

const RECENT_SEARCHES_MAX_ITEM_COUNT_LIMIT = 10;

const NOTIFICATION_MESSAGE_LOGIN_REQUIRED = 'Login required';
const NOTIFICATION_CAPTION_MUST_LOG_IN_CAPTION = 'You must log in to perform this action.';
const NOTIFICATION_MESSAGE_SEARCH_RESTORATION_FAILED = 'Search restoration failed'

const SORT_BY_BADGE_RANK = 'badge_rank';
const SORT_BY_PARTNER_NAME = 'partner_name.keyword';
const SORT_BY_DIVERSE_PARTNER = 'diverse_rank';
const SORT_BY_DIVERSITY = '';
const SORT_BY_EXPERTISE_COUNT = '';
const SORT_ORDER_ASC = 'ASC';
const SORT_ORDER_DESC = 'DESC';

const RECORD_COUNT_PER_PAGE = 12;

const COMPARATOR_LIST_ITEMS_SHOW_MAX = 5;
const COMPARATOR_LONG_TEXT_SHOW_MAX = 150;

const COPYRIGHT_YEAR = '2022';

const CDC_LINK_URL_QUICK_LINKS_ABOUT_CISCO = 'https://www.cisco.com/c/en/us/about.html';
const CDC_LINK_URL_QUICK_LINKS_CONTACT_US = 'https://www.cisco.com/c/en/us/about/contact-cisco.html';
const CDC_LINK_URL_QUICK_LINKS_CAREERS = 'https://www.cisco.com/c/en/us/about/careers.html';
const CDC_LINK_URL_QUICK_LINKS_MEET_OUT_PARTNERS = 'https://www.cisco.com/c/en/us/partners/connect-with-a-partner.html';

const CDC_LINK_URL_RESOURCES_LEGAL_FEEDBACK = 'https://ciscocx.qualtrics.com/jfe/form/SV_0Tcp9VU8pUm4lBY?Ref=/c/en/us/index.html';
const CDC_LINK_URL_RESOURCES_LEGAL_HELP = 'https://www.cisco.com/c/en/us/about/help.html';
const CDC_LINK_URL_RESOURCES_LEGAL_TERMS_AND_CONDITIONS = 'https://www.cisco.com/c/en/us/about/legal/terms-conditions.html';
const CDC_LINK_URL_RESOURCES_LEGAL_PRIVACY_STATEMENT = 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html';
const CDC_LINK_URL_RESOURCES_LEGAL_COOKIES = 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies';
const CDC_LINK_URL_RESOURCES_LEGAL_TRADEMARKS = 'https://www.cisco.com/c/en/us/about/legal/trademarks.html';
const CDC_LINK_URL_RESOURCES_LEGAL_SUPPLY_CHAIN_TRANSPARENCY = 'https://www.cisco.com/c/dam/en_us/about/supply-chain/cisco-modern-slavery-statement.pdf';
const CDC_LINK_URL_RESOURCES_LEGAL_SITEMAP = 'https://www.cisco.com/c/en/us/about/sitemap.html';

const CDC_LINK_URL_SOCIAL_FACEBOOK = 'https://www.facebook.com/Cisco/';
const CDC_LINK_URL_SOCIAL_TWITTER = 'https://twitter.com/Cisco/';
const CDC_LINK_URL_SOCIAL_LINKEDIN = 'https://www.linkedin.com/company/cisco';
const CDC_LINK_URL_SOCIAL_YOUTUBE = 'https://www.youtube.com/user/cisco';
const CDC_LINK_URL_SOCIAL_INSTAGRAM = 'https://www.instagram.com/cisco/';

const CDC_LINK_URL_UTILITY_HOW_TO_BUY = 'https://www.cisco.com/c/en/us/buy.html';
const CDC_LINK_URL_UTILITY_PARTNERS = 'https://www.cisco.com/c/en/us/partners.html';

const CDC_LINK_URL_NAVIGATION_GROUP_1_PRODUCT_AND_SERVICES = 'https://www.cisco.com/c/en/us/products/index.html';
const CDC_LINK_URL_NAVIGATION_GROUP_1_SOLUTIONS = 'https://www.cisco.com/c/en/us/solutions/index.html';
const CDC_LINK_URL_NAVIGATION_GROUP_1_SUPPORT = 'https://www.cisco.com/c/en/us/support/index.html';
const CDC_LINK_URL_NAVIGATION_GROUP_1_LEARN = 'https://www.cisco.com/c/en/us/training-events.html';

const CDC_LINK_URL_NAVIGATION_GROUP_2_EXPLORE_CISCO = 'https://www.cisco.com/c/en/us/about/sitemap.html';

const CDC_LINK_URL_SIGN_UP = 'https://id.cisco.com/signin/register';

const CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_FACEBOOK = 'CCIconSocialFacebook20x20';
const CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_TWITTER = 'CCIconSocialTwitter20x20';
const CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_LINKEDIN = 'CCIconSocialLinkedIn20x20';
const CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_YOUTUBE = 'CCIconSocialYouTube20x20';
const CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_INSTAGRAM = 'CCIconSocialInstagram20x20';

const CDC_LINKS = {
  quickLinks: [
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_ABOUT_CISCO, url: CDC_LINK_URL_QUICK_LINKS_ABOUT_CISCO, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_CONTACT_US, url: CDC_LINK_URL_QUICK_LINKS_CONTACT_US, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_CAREERS, url: CDC_LINK_URL_QUICK_LINKS_CAREERS, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS, url: CDC_LINK_URL_QUICK_LINKS_MEET_OUT_PARTNERS, target: '_self' },
  ],
  resourcesAndLegal: [
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_FEEDBACK, url: CDC_LINK_URL_RESOURCES_LEGAL_FEEDBACK, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_HELP, url: CDC_LINK_URL_RESOURCES_LEGAL_HELP, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS, url: CDC_LINK_URL_RESOURCES_LEGAL_TERMS_AND_CONDITIONS, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT, url: CDC_LINK_URL_RESOURCES_LEGAL_PRIVACY_STATEMENT, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_COOKIES, url: CDC_LINK_URL_RESOURCES_LEGAL_COOKIES, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_TRADEMARKS, url: CDC_LINK_URL_RESOURCES_LEGAL_TRADEMARKS, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY, url: CDC_LINK_URL_RESOURCES_LEGAL_SUPPLY_CHAIN_TRANSPARENCY, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_SITEMAP, url: CDC_LINK_URL_RESOURCES_LEGAL_SITEMAP, target: '_self' },
  ],
  social: [
    { iconComponentName: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_FACEBOOK, title: 'facebook', url: CDC_LINK_URL_SOCIAL_FACEBOOK, target: '_self' },
    { iconComponentName: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_TWITTER,  title: 'twitter',  url: CDC_LINK_URL_SOCIAL_TWITTER, target: '_self' },
    { iconComponentName: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_LINKEDIN, title: 'linkedin', url: CDC_LINK_URL_SOCIAL_LINKEDIN, target: '_self' },
    { iconComponentName: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_YOUTUBE, title: 'youtube', url: CDC_LINK_URL_SOCIAL_YOUTUBE, target: '_self' },
    { iconComponentName: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_INSTAGRAM, title: 'instagram', url: CDC_LINK_URL_SOCIAL_INSTAGRAM, target: '_self' }
  ],
  utility: [
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_HOW_TO_BUY, url: CDC_LINK_URL_UTILITY_HOW_TO_BUY, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_PARTNERS, url: CDC_LINK_URL_UTILITY_PARTNERS, target: '_self' },
  ],
  navigationGroup1: [
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES, url: CDC_LINK_URL_NAVIGATION_GROUP_1_PRODUCT_AND_SERVICES, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_SOLUTIONS, url: CDC_LINK_URL_NAVIGATION_GROUP_1_SOLUTIONS, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_SUPPORT, url: CDC_LINK_URL_NAVIGATION_GROUP_1_SUPPORT, target: '_self' },
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_LEARN, url: CDC_LINK_URL_NAVIGATION_GROUP_1_LEARN, target: '_self' },
  ],
  navigationGroup2: [
    { l18nLabelKey: KEYS.L18N_KEY_LABEL_EXPLORE_CISCO, url: CDC_LINK_URL_NAVIGATION_GROUP_2_EXPLORE_CISCO, target: '_self' },
  ],
  signUp: CDC_LINK_URL_SIGN_UP
}

const constants = Object.freeze({
  APP_ROOT_ID: 'pf-app',
  APP_DEBUG_LOGGER: 'production' !== process.env.NODE_ENV ? console.warn : null,

  APP_BROWSER_ROUTER_BASENAME: !!window &&
  ('_globalPartnerFinderServerData' in window) &&
  ('serverContextPath' in window['_globalPartnerFinderServerData']) ?
    `${window['_globalPartnerFinderServerData'].serverContextPath}/pf` :
    '/',

  APP_PAGE_HOME_ROUTE_PATH: '/',
  APP_PAGE_PARTNER_PROFILE_ROUTE_PATH: '/partner/:partnerId',

  PARTNER_LOGO_CISCO_CDN_URL:
    !!window &&
    ('_globalPartnerFinderServerData' in window) &&
    ('env' in window['_globalPartnerFinderServerData']) ?
      window['_globalPartnerFinderServerData'].env === 'prod' ? 'https://www.cisco.com/web/fw/tools/onepx/ploclogos/' : 'https://www-stage.cisco.com/web/fw/tools/onepx/ploclogos/' : 'https://www-stage.cisco.com/web/fw/tools/onepx/ploclogos/',

  PARTNER_LOGO_FILE_EXTENSION: '.png',

  RECORD_COUNT_PER_PAGE: RECORD_COUNT_PER_PAGE,
  PARTNER_FOUND_RECORD_COUNT_PER_PAGE: RECORD_COUNT_PER_PAGE,

  ELOQUA_FORM_URL_GET_GUIDANCE: ELOQUA_FORM_URL_GET_GUIDANCE,
  ELOQUA_FORM_URL_GET_QUOTE: ELOQUA_FORM_URL_GET_QUOTE,
  ELOQUA_FORM_GET_QUOTE_AUTHORIZED_BE_GEO_IDS: ELOQUA_FORM_GET_QUOTE_AUTHORIZED_BE_GEO_IDS,

  SSO_LOGIN_URL: SSO_LOGIN_URL,
  SSO_LOGOUT_URL: SSO_LOGOUT_URL,

  KEY_NAME: KEY_NAME,
  KEY_CODE: KEY_CODE,
  KEY_IS_SELECTED: KEY_IS_SELECTED,
  KEY_IS_ACTIVE: KEY_IS_ACTIVE,
  KEY_IS_DISABLED: KEY_IS_DISABLED,
  KEY_IS_GROUP: KEY_IS_GROUP,
  KEY_GROUP: KEY_GROUP,
  KEY_TYPE: KEY_TYPE,
  KEY_SUBTYPE: KEY_SUBTYPE,
  KEY_ORIGINAL_DATA: KEY_ORIGINAL_DATA,
  KEY_KEYWORD_ID: KEY_KEYWORD_ID,
  KEY_SEARCH_PARAM: KEY_SEARCH_PARAM,
  KEY_KEYWORD_IDS: KEY_KEYWORD_IDS,
  KEY_KEYWORD_DISPLAY_NAME: KEY_KEYWORD_DISPLAY_NAME,
  KEY_CATEGORY_ID: KEY_CATEGORY_ID,
  KEY_CATEGORY_DISPLAY_NAME: KEY_CATEGORY_DISPLAY_NAME,
  KEY_PARENT_CATEGORY_ID: KEY_PARENT_CATEGORY_ID,
  KEY_PARENT_CATEGORY_DESC: KEY_PARENT_CATEGORY_DESC,
  KEY_DOCLIST: KEY_DOCLIST,
  KEY_GROUPVALUE: KEY_GROUPVALUE,
  KEY_JSONKEY: KEY_JSONKEY,
  KEY_KEYWORD_SUBTEXT: KEY_KEYWORD_SUBTEXT,

  KEY_LOCATION_IDS: KEY_LOCATION_IDS,
  KEY_SPECIALIZATION_IDS: KEY_SPECIALIZATION_IDS,
  KEY_LEVEL_IDS: KEY_LEVEL_IDS,
  KEY_SITE_ID: KEY_SITE_ID,
  KEY_SITE_ID_LOWERCASE: KEY_SITE_ID_LOWERCASE,
  KEY_SITEID: KEY_SITEID,
  KEY_SITE_IDS: KEY_SITE_IDS,
  KEY_PARTNER_KEYWORD_ID: KEY_PARTNER_KEYWORD_ID,
  KEY_PARTNER_KEYWORD_IDS: KEY_PARTNER_KEYWORD_IDS,
  KEY_SORT_ORDER: KEY_SORT_ORDER,
  KEY_SORT_BY: KEY_SORT_BY,
  KEY_PAGE_COUNT: KEY_PAGE_COUNT,
  KEY_PAGE_SIZE: KEY_PAGE_SIZE,

  KEY_QUAL_ICONS: KEY_QUAL_ICONS,
  KEY_GLOBAL_GOLD_CERTIFICATION: KEY_GLOBAL_GOLD_CERTIFICATION,
  KEY_CERTIFICATION: KEY_CERTIFICATION,
  KEY_MASTER: KEY_MASTER,
  KEY_SMB: KEY_SMB,
  KEY_CUSTOMER: KEY_CUSTOMER,
  KEY_PROVIDER_LOWERCASE: KEY_PROVIDER_LOWERCASE,

  KEY_ROLES_AND_LEVELS: KEY_ROLES_AND_LEVELS,
  KEY_INTEGRATOR: KEY_INTEGRATOR,
  KEY_PROVIDER: KEY_PROVIDER,
  KEY_DEVELOPER: KEY_DEVELOPER,
  KEY_ADVISOR: KEY_ADVISOR,
  KEY_IS_SAVED: KEY_IS_SAVED,

  KEY_ATTRIBUTE_LIST_TITLE: KEY_ATTRIBUTE_LIST_TITLE,
  KEY_ATTRIBUTE_LIST_ITEMS: KEY_ATTRIBUTE_LIST_ITEMS,

  KEY_FAVPARTNERLIST: KEY_FAVPARTNERLIST,
  KEY_USE_GRID_DISPLAY: KEY_USE_GRID_DISPLAY,

  VALUE_Y: VALUE_Y,
  VALUE_N: VALUE_N,
  VALUE_PARTNER_ROLE: VALUE_PARTNER_ROLE,
  VALUE_INTEGRATOR: VALUE_INTEGRATOR,
  VALUE_PROVIDER: VALUE_PROVIDER,
  VALUE_DEVELOPER: VALUE_DEVELOPER,
  VALUE_ADVISOR: VALUE_ADVISOR,
  VALUE_PARTNER_LEVEL: VALUE_PARTNER_LEVEL,
  VALUE_PARTNER_SPECIALIZATION: VALUE_PARTNER_SPECIALIZATION,
  VALUE_CISCO_POWERED_SERVICE: VALUE_CISCO_POWERED_SERVICE,
  VALUE_PARTNER_NAME: VALUE_PARTNER_NAME,
  VALUE_LOCATION: VALUE_LOCATION,
  VALUE_COUNTRY: VALUE_COUNTRY,
  VALUE_PARTNER_NAME_KEYWORD: VALUE_PARTNER_NAME_KEYWORD,
  VALUE_SORTING: VALUE_SORTING,
  VALUE_SPECIALIZATIONS: VALUE_SPECIALIZATIONS,
  VALUE_PARTNER_SPECIALIZATIONS: VALUE_PARTNER_SPECIALIZATIONS,
  VALUE_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES: VALUE_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES,
  VALUE_DIVERSE_PARTNERS: VALUE_DIVERSE_PARTNERS,

  PROVIDER_LEVELS: [VALUE_GOLD_PROVIDER, VALUE_PREMIER_PROVIDER, VALUE_SELECT_PROVIDER],

  GROUPVALUE_PARTNER_LEVEL: GROUPVALUE_PARTNER_LEVEL,
  GROUPVALUE_PARTNER_SPECIALIZATIONS: GROUPVALUE_PARTNER_SPECIALIZATIONS,
  GROUPVALUE_PARTNER_NAME: GROUPVALUE_PARTNER_NAME,
  GROUP_NAME_VALUE_SEARCH_TERMS: GROUP_NAME_VALUE_SEARCH_TERMS,

  SEARCH_FORM_FILTER_BY_NEED: FORM_FILTER_BY_NEED,
  SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA: FORM_SEARCH_BY_COMBINED_CRITERIA,
  SEARCH_FORM_SEARCH_BY_LOCATION: FORM_SEARCH_BY_LOCATION,
  SEARCH_FORMS: [FORM_FILTER_BY_NEED, FORM_SEARCH_BY_COMBINED_CRITERIA, FORM_SEARCH_BY_LOCATION],
  SEARCH_FORM_DEFAULT: FORM_SEARCH_BY_LOCATION,

  LABEL_ELOQUA__GET_GUIDANCE: LABEL_ELOQUA__GET_GUIDANCE,
  LABEL_ELOQUA__REQUEST_A_QUOTE: LABEL_ELOQUA__REQUEST_A_QUOTE,

  LABEL_OPEN: LABEL_OPEN,
  LABEL_EXPAND: LABEL_EXPAND,
  LABEL_COLLAPSE: LABEL_COLLAPSE,
  LABEL_CHOOSE_A_COUNTRY: LABEL_CHOOSE_A_COUNTRY,
  LABEL_CHOOSE_A_ROLE: LABEL_CHOOSE_A_ROLE,
  LABEL_CHOOSE_SPECIALIZATION_S_: LABEL_CHOOSE_SPECIALIZATION_S_,
  LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_: LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_,
  LABEL_CHOOSE_EXPERTISE_S: LABEL_CHOOSE_EXPERTISE_S,
  LABEL_PARTNER_SPECIALIZATION: LABEL_PARTNER_SPECIALIZATION,
  LABEL_CISCO_POWERED_SERVICE: LABEL_CISCO_POWERED_SERVICE,
  LABEL_PARTNER_EXPERTISE: LABEL_PARTNER_EXPERTISE,
  LABEL_PARTNER_COUNTRY: LABEL_PARTNER_COUNTRY,

  LABEL_CHOOSE_LEVEL_S_: LABEL_CHOOSE_LEVEL_S_,
  LABEL_INTEGRATOR_LEVELS: LABEL_INTEGRATOR_LEVELS,
  LABEL_PROVIDER_LEVELS: LABEL_PROVIDER_LEVELS,
  LABEL_DEVELOPER_LEVELS: LABEL_DEVELOPER_LEVELS,
  LABEL_ADVISOR_LEVELS: LABEL_ADVISOR_LEVELS,
  LABEL_INTEGRATOR_SPECIALIZATIONS: LABEL_INTEGRATOR_SPECIALIZATIONS,
  LABEL_CISCO_POWERED_SERVICES: LABEL_CISCO_POWERED_SERVICES,
  LABEL_PARTNER_NAMES: LABEL_PARTNER_NAMES,
  LABEL_PARTNER_NAME_KEYWORD: LABEL_PARTNER_NAME_KEYWORD,
  LABEL_PARTNER_NAME_KEYWORD_S_: LABEL_PARTNER_NAME_KEYWORD_S_,

  LABEL_BACK: LABEL_BACK,

  LABEL_ALL_RESULTS: LABEL_ALL_RESULTS,
  LABEL_ALL: LABEL_ALL,
  LABEL_SAVED: LABEL_SAVED,
  LABEL_MY_PARTNERS: LABEL_MY_PARTNERS,

  LABEL_ADD: LABEL_ADD,
  LABEL_REMOVE: LABEL_REMOVE,
  LABEL_ADD_TO_COMPARE: LABEL_ADD_TO_COMPARE,
  LABEL_SELECT_AT_LEAST_ONE_MORE: LABEL_SELECT_AT_LEAST_ONE_MORE,
  LABEL_COMPARE_SELECTED: LABEL_COMPARE_SELECTED,
  LABEL_REMOVE_FROM_COMPARATOR: LABEL_REMOVE_FROM_COMPARATOR,
  LABEL_COMPARE: LABEL_COMPARE,
  LABEL_PROCESSING_IN_PROGRESS: LABEL_PROCESSING_IN_PROGRESS,

  LABEL_RESULT: LABEL_RESULT,
  LABEL_RESULTS: LABEL_RESULTS,
  LABEL_NO_RESULTS: LABEL_NO_RESULTS,

  LABEL_RESULT_IN_: LABEL_RESULT_IN_,
  LABEL_RESULTS_IN_: LABEL_RESULTS_IN_,
  LABEL_NO_RESULTS_IN_: LABEL_NO_RESULTS_IN_,

  LABEL_PREVIOUS: LABEL_PREVIOUS,
  LABEL_PREV: LABEL_PREV,
  LABEL_NEXT: LABEL_NEXT,
  LABEL_SAVE: LABEL_SAVE,
  LABEL_EXPERTISE: LABEL_EXPERTISE,
  LABEL_OVERVIEW: LABEL_OVERVIEW,
  LABEL_IS_A_CISCO: LABEL_IS_A_CISCO,

  LABEL_PAST_SEARCHES: LABEL_PAST_SEARCHES,
  LABEL_PAST_SEARCH: LABEL_PAST_SEARCH,

  LABEL_ROLE_DESCRIPTION_MAPPING: {
    [VALUE_INTEGRATOR]: LABEL_ROLE_INTEGRATOR_DESCRIPTION,
    [VALUE_PROVIDER]: LABEL_ROLE_PROVIDER_DESCRIPTION,
    [VALUE_DEVELOPER]: LABEL_ROLE_DEVELOPER_DESCRIPTION,
    [VALUE_ADVISOR]: LABEL_ROLE_ADVISOR_DESCRIPTION,
  },

  LABEL_ROLE_QUALIFICATION_NAME_MAPPING: {
    [VALUE_INTEGRATOR]: 'L18N_KEY_LABEL_SPECIALIZATIONS',
    [VALUE_PROVIDER]: 'L18N_KEY_LABEL_CISCO_POWERED_SERVICES',
    [VALUE_DEVELOPER]: 'L18N_KEY_LABEL_EXPERTISES',
    [VALUE_ADVISOR]: 'L18N_KEY_LABEL_EXPERTISES'
  },

  LABEL_SPECIALIZATIONS: LABEL_SPECIALIZATIONS,

  LABEL_ROLES: LABEL_ROLES,
  LABEL_TECHNOLOGY: LABEL_TECHNOLOGY,
  LABEL_INDUSTRIES: LABEL_INDUSTRIES,

  LABEL_INTEGRATOR: LABEL_INTEGRATOR,
  LABEL_INTEGRATORS: LABEL_INTEGRATORS,
  LABEL_PROVIDER: LABEL_PROVIDER,
  LABEL_PROVIDERS: LABEL_PROVIDERS,
  LABEL_DEVELOPER: LABEL_DEVELOPER,
  LABEL_DEVELOPERS:LABEL_DEVELOPERS,
  LABEL_ADVISOR:LABEL_ADVISOR,
  LABEL_ADVISORS:LABEL_ADVISORS,
  LABEL_OTHER: LABEL_OTHER,
  LABEL_OTHERS: LABEL_OTHERS,

  LABEL_NO_SAVED_INTEGRATORS: LABEL_NO_SAVED_INTEGRATORS,
  LABEL_NO_SAVED_PROVIDERS: LABEL_NO_SAVED_PROVIDERS,
  LABEL_NO_SAVED_OTHER_PARTNERS: LABEL_NO_SAVED_OTHER_PARTNERS,

  NOTIFICATION_TYPE_INFO: NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_SUCCESS: NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_WARNING: NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_ALERT: NOTIFICATION_TYPE_ALERT,
  DELAY_INFINITE: DELAY_INFINITE,
  DELAY_MILLISECONDS_3000: DELAY_MILLISECONDS_3000,
  DELAY_MILLISECONDS_5000: DELAY_MILLISECONDS_5000,
  DELAY_MILLISECONDS_7000: DELAY_MILLISECONDS_7000,

  SEARCH_TERMS_GET_SUGGESTION_DEBOUNCE_DELAY_MILLISECONDS: DELAY_MILLISECONDS_500,

  COMPARATOR_MIN_ITEM_COUNT_LIMIT: COMPARATOR_MIN_ITEM_COUNT_LIMIT,
  COMPARATOR_MAX_ITEM_COUNT_LIMIT: COMPARATOR_MAX_ITEM_COUNT_LIMIT,

  RECENT_SEARCHES_MAX_ITEM_COUNT_LIMIT: RECENT_SEARCHES_MAX_ITEM_COUNT_LIMIT,

  NOTIFICATION_MESSAGE_LOGIN_REQUIRED: NOTIFICATION_MESSAGE_LOGIN_REQUIRED,
  NOTIFICATION_CAPTION_MUST_LOG_IN_CAPTION: NOTIFICATION_CAPTION_MUST_LOG_IN_CAPTION,
  NOTIFICATION_MESSAGE_SEARCH_RESTORATION_FAILED: NOTIFICATION_MESSAGE_SEARCH_RESTORATION_FAILED,

  COMPARATOR_LIST_ITEMS_SHOW_MAX: COMPARATOR_LIST_ITEMS_SHOW_MAX,
  COMPARATOR_LONG_TEXT_SHOW_MAX: COMPARATOR_LONG_TEXT_SHOW_MAX,

  SORT_BY_BADGE_RANK: SORT_BY_BADGE_RANK,
  SORT_BY_PARTNER_NAME: SORT_BY_PARTNER_NAME,
  SORT_BY_DIVERSE_PARTNER: SORT_BY_DIVERSE_PARTNER,
  SORT_ORDER_ASC: SORT_ORDER_ASC,
  SORT_ORDER_DESC: SORT_ORDER_DESC,
  SORTING_PARAMETER_DEFAULT: {
    [KEY_SORT_BY]: SORT_BY_BADGE_RANK,
    [KEY_SORT_ORDER]: SORT_ORDER_ASC
   },

  HEADER_CONTENT_TYPE: HEADER_CONTENT_TYPE,
  CONTENT_TYPE_APPLICATION_JSON: CONTENT_TYPE_APPLICATION_JSON,

  SERVICE_ERROR_INVALID_RESPONSE_CONTENT_TYPE: 'Invalid response content type.',
  SERVICE_ERROR_INVALID_RESPONSE_MISSING_ATTRIBUTE: 'Invalid response: one or more response attribute is missing.',

  SERVICE_BASE_URL:
    !!window &&
    ('_globalPartnerFinderServerData' in window) &&
    ('serverContextPath' in window['_globalPartnerFinderServerData']) ?
      window['_globalPartnerFinderServerData'].serverContextPath :
      '/tomcat7',



  NAVIGATOR_GEOLOCATION_SETTINGS: {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 0
  },

  LOCALSTORAGE_KEY_RECENT_SEARCHES : 'partnerFinder_recentSearches',
  LOCALSTORAGE_KEY_LOGGED_IN_USER: 'partnerFinder_loggedInUser',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_COUNTRY: 'partnerFinder_persistedSelectedCountry',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_PARTNER_ROLE: 'partnerFinder_persistedSelectedPartnerRole',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_PARTNER_LEVELS: 'partnerFinder_persistedSelectedPartnerLevels',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_PARTNER_EXPERTISES: 'partnerFinder_persistedSelectedPartnerExpertises',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_PARTNER_SEARCH_FORM: 'partnerFinder_persistedSelectedPartnerSearchForm',
  LOCALSTORAGE_KEY_PERSISTED_LAST_SELECTED_PARTNER_SEARCH_FORM: 'partnerFinder_persistedLastSelectedPartnerSearchForm',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_PARTNER_SITE_ID: 'partnerFinder_persistedSelectedPartnerSiteId',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SORTING_PARAMETER: 'partnerFinder_persistedSelectedSortingParameter',
  LOCALSTORAGE_KEY_PERSISTED_CURRENT_PAGE_INDEX: 'partnerFinder_persistedCurrentPageIndex',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_INTEGRATOR_LEVELS: 'partnerFinder_persistedSelectedPartnerIntegratorLevelSuggestions',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_PROVIDER_LEVELS: 'partnerFinder_persistedSelectedPartnerProviderLevelSuggestions',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_DEVELOPER_LEVELS: 'partnerFinder_persistedSelectedPartnerDeveloperLevelSuggestions',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_ADVISOR_LEVELS: 'partnerFinder_persistedSelectedPartnerAdvisorLevelSuggestions',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_INTEGRATOR_SPECIALIZATIONS: 'partnerFinder_persistedSelectedPartnerIntegratorSpecializationSuggestions',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_PROVIDER_CPS: 'partnerFinder_persistedSelectedPartnerProviderCiscoPoweredServiceSuggestions',
  LOCALSTORAGE_KEY_PERSISTED_SELECTED_SUGGESTION_PARTNER_NAME: 'partnerFinder_persistedSelectedPartnerNameSuggestion',


  COPYRIGHT_YEAR: COPYRIGHT_YEAR,

  CDC_LINK_URL_QUICK_LINKS_ABOUT_CISCO: CDC_LINK_URL_QUICK_LINKS_ABOUT_CISCO,
  CDC_LINK_URL_QUICK_LINKS_CONTACT_US: CDC_LINK_URL_QUICK_LINKS_CONTACT_US,
  CDC_LINK_URL_QUICK_LINKS_CAREERS: CDC_LINK_URL_QUICK_LINKS_CAREERS,
  CDC_LINK_URL_QUICK_LINKS_MEET_OUT_PARTNERS: CDC_LINK_URL_QUICK_LINKS_MEET_OUT_PARTNERS,
  CDC_LINK_URL_RESOURCES_LEGAL_FEEDBACK: CDC_LINK_URL_RESOURCES_LEGAL_FEEDBACK,
  CDC_LINK_URL_RESOURCES_LEGAL_HELP: CDC_LINK_URL_RESOURCES_LEGAL_HELP,
  CDC_LINK_URL_RESOURCES_LEGAL_TERMS_AND_CONDITIONS: CDC_LINK_URL_RESOURCES_LEGAL_TERMS_AND_CONDITIONS,
  CDC_LINK_URL_RESOURCES_LEGAL_PRIVACY_STATEMENT: CDC_LINK_URL_RESOURCES_LEGAL_PRIVACY_STATEMENT,
  CDC_LINK_URL_RESOURCES_LEGAL_COOKIES: CDC_LINK_URL_RESOURCES_LEGAL_COOKIES,
  CDC_LINK_URL_RESOURCES_LEGAL_TRADEMARKS: CDC_LINK_URL_RESOURCES_LEGAL_TRADEMARKS,
  CDC_LINK_URL_RESOURCES_LEGAL_SUPPLY_CHAIN_TRANSPARENCY: CDC_LINK_URL_RESOURCES_LEGAL_SUPPLY_CHAIN_TRANSPARENCY,
  CDC_LINK_URL_RESOURCES_LEGAL_SITEMAP: CDC_LINK_URL_RESOURCES_LEGAL_SITEMAP,

  CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_FACEBOOK: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_FACEBOOK,
  CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_TWITTER: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_TWITTER,
  CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_LINKEDIN: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_LINKEDIN,
  CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_YOUTUBE: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_YOUTUBE,
  CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_INSTAGRAM: CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_INSTAGRAM,

  CDC_LINKS: CDC_LINKS,

  SERVICE_REQUEST_GOOGLE_GEOLOCATION_GEOLOCATE_API_KEY: 'AIzaSyD96CxUUKN_VLANHcDTx7lkzdw0v37oUHk',
  SERVICE_REQUEST_GOOGLE_GEOLOCATION_GEOLOCATE_URL: `https://www.googleapis.com/geolocation/v1/geolocate`,
  SERVICE_REQUEST_GOOGLE_GEOLOCATION_GEOLOCATE_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },


  SERVICE_REQUEST_FETCH_USER_COUNTRY_URL: '/service/locationService/getUserCountry',
  SERVICE_REQUEST_FETCH_USER_COUNTRY_CONFIG: {
    method: METHOD_GET,
    mode: MODE_NO_CORS,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_TEXT_PLAIN]
        ]
      )
    )
  },

  //crossDomain: true,
  //processdata: true,
  //async: false,
  //timeout: null
  SERVICE_REQUEST_GET_LOGGED_IN_USER_URL: '/service/authorizationService/getUserWithLDAP',
  SERVICE_REQUEST_GET_LOGGED_IN_USER_CONFIG: {
    method: METHOD_GET,
    mode: MODE_CORS,
    credentials: CREDENTIALS_INCLUDE,
    cache: 'no-cache',
    referrer: 'same-origin',
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },


  SERVICE_REQUEST_GET_FILTERS_URL: '/service/api/v1/getPfFilters',
  SERVICE_REQUEST_GET_FILTERS_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_GET_COMBINED_SUGGESTIONS_URL: '/service/api/v1/getPfSuggestion',
  SERVICE_REQUEST_GET_COMBINED_SUGGESTIONS_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_SAVE_USER_PARTNER_URL: '/service/trackingService/updateFavorites',
  SERVICE_REQUEST_SAVE_USER_PARTNER_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_DELETE_USER_PARTNER_URL: '/service/trackingService/updateFavorites',
  SERVICE_REQUEST_DELETE_USER_PARTNER_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },


  SERVICE_REQUEST_GET_USER_SAVED_PARTNERS_URL: '/service/trackingService/getFavPartners',
  SERVICE_REQUEST_GET_USER_SAVED_PARTNERS_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_SAVE_USER_SEARCH_URL: '/service/trackingService/saveSearchRequest',
  SERVICE_REQUEST_SAVE_USER_SEARCH_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },
  SERVICE_REQUEST_GET_USER_SAVED_SEARCHES_URL: '/service/trackingService/getUserSearches',
  SERVICE_REQUEST_GET_USER_SAVED_SEARCHES_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_GET_PARTNER_USER_SAVED_COUNT_URL : '/service/trackingService/getFavPartnersCount',
  SERVICE_REQUEST_GET_PARTNER_USER_SAVED_COUNT_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_SEARCH_PARTNERS_URL: '/service/api/v1/getPfPartners',
  SERVICE_REQUEST_SEARCH_PARTNERS_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_FETCH_PARTNERS_URL: '/service/api/v1/getPfPartners',
  SERVICE_REQUEST_FETCH_PARTNERS_CONFIG: {
    method: METHOD_POST,
    headers: Object.fromEntries(
      new Map(
        [
          [HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_JSON]
        ]
      )
    )
  },

  SERVICE_REQUEST_FETCH_ELOQUA_URLS_URL: '/service/plocnextgen/getPartnerQuoteGuidanceDetails',
  SERVICE_REQUEST_FETCH_ELOQUA_URLS_CONFIG: {
    method: METHOD_POST,
    headers: {
      [HEADER_CONTENT_TYPE]: CONTENT_TYPE_APPLICATION_JSON
    }
  }

});

export default constants;
